import { DynamicFormModal } from '@/shared/components/dynamic-form/DynamicFormModal/DynamicFormModal';
import { type ModalComponentProps } from '@/shared/components/Modals/modal-registry/modal-registry.types';

import { type DirectPriceDraft } from '../../hooks/useDirectPrices/useDirectPrices';

import { useDirectPriceEditorModalLogic } from './useDirectPriceEditorModalLogic';

/**
 * One plan's direct price, per gender.
 *
 * Presentation only; every decision — what the boxes are seeded from, what each
 * sentence says, which scopes a save touches — is in
 * `useDirectPriceEditorModalLogic` (U5).
 */
export function DirectPriceEditorModal({ open, onCancel, modalData }: ModalComponentProps) {
  const productKey = typeof modalData?.['productKey'] === 'string' ? modalData['productKey'] : '';
  const view = useDirectPriceEditorModalLogic({
    productKey,
    productName: typeof modalData?.['productName'] === 'string' ? modalData['productName'] : '',
    onDone: onCancel,
  });

  return (
    <DynamicFormModal<DirectPriceDraft>
      isOpen={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) onCancel();
      }}
      title={view.title}
      description={view.description}
      size="md"
      // Withheld until the prices arrive: RHF reads `defaultValues` once, and a
      // form mounted before the load would open on three empty boxes and offer
      // to save them as "no price at any scope" (P21c).
      isLoading={view.isLoading}
      fields={view.fields}
      schema={view.schema}
      initialValues={view.initialValues}
      submitLabel={view.saveLabel}
      onCancel={onCancel}
      onSubmit={view.submit}
    />
  );
}
